// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__A+Z1L","spacer":"nav_spacer__m-+Se","nav_item":"nav_nav_item__IkaYo","active":"nav_active__-8Dcn","docs_link":"nav_docs_link__MqBc2"};